function CountryView() {
  return (
    <div>
      Country View
    </div>
  )
}

export default CountryView
